import { Action } from '..';

export type Modal =
    | null
    | 'Landing/Rate'
    | 'Messages/Send'
    | 'Messages/Reply'
    | 'Performance/Info/Activity'
    | 'Performance/Info/Biking'
    | 'Performance/Info/Chart'
    | 'Performance/Info/Checkpoint'
    | 'Performance/Info/Goal'
    | 'Performance/Info/MySpeed'
    | 'Performance/Info/OurSpeed'
    | 'Performance/Info/Running'
    | 'Performance/Info/TotalMiles'
    | 'Performance/Info/PathGroupMilesAvg'
    | 'Performance/Info/PathGroupMilesTotal'
    | 'Performance/Info/PathGroupSpeedometer'
    | 'Profile/ChangeAvatar'
    | 'Profile/ChangePassword'
    | 'Profile/ChangeProfilePicture'
    | 'SubmittedTask/PollResults'
    | 'SubmittedTask/QuizResults'
    | 'Task/CollectFeedback/AllResponses'
    | 'Task/CollectFeedback/IndividualResponse'
    | 'Task/CollectFeedback/Preview'
    | 'Task/Info/CollectFeedbackHeading'
    | 'Task/Info/CollectFeedbackQuestions'
    | 'Task/Info/MultiQuestion'
    | 'Task/PollResults'
    | 'Task/QuizResults'
    | 'TasksSidebar/Info'
    | 'TeamScan/Info/ReportSLNetwork'
    | 'TeamScan/Info/ReportSLOverview'
    | 'TeamScan/Info/ReportTLBDetails'
    | 'TeamScan/Info/ReportTLBOverview'
    | 'TeamScan/Info/ReportTPSDetails'
    | 'TeamScan/Info/ReportTPSOverview'
    | 'TeamScan/ProgressEditEmail';

export interface ModalState {
    open: Modal;
}

const initialState: ModalState = {
    open: null,
};

export function reducer(state: ModalState = initialState, action: Action): ModalState {
    switch (action.type) {
        case 'OPEN_MODAL':
            return {
                ...state,
                open: action.modal,
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                open: null,
            };
        default:
            return state;
    }
}
